// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__20-TO","colCheckbox":"styles_colCheckbox__45ace"};